import { render, staticRenderFns } from "./StacLink.vue?vue&type=template&id=935ce1da"
import script from "./StacLink.vue?vue&type=script&lang=js"
export * from "./StacLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports